import React, { useContext } from "react";
import { InputBaseProps } from "./InputBase";
import { MaskedInput } from "./MaskedInput";
import { LabelContext } from "../labels/LabelContext";

export interface NumberInputProps extends InputBaseProps<number|null> {
  options?: Omit<IMask.MaskedNumber, "mask">
}

/**
 * Input element with the corresponding aria tags.
 */
export const NumberInput: React.FC<NumberInputProps> = ({
  options = {},
  rightAlign = true,
  ...props
}) => {
  const handleOnChange = (value: string) => {
    let formattedValue: number =  parseFloat(value.replace(/[^\d.+-]/g, ""));
    if(isNaN(formattedValue)) {
      props.onChange && props.onChange(null);  
    }
    else {
      props.onChange && props.onChange(formattedValue);
    }
  };

  const labelCtx = useContext(LabelContext);
  return (
    <MaskedInput
      {...props}
      id={props.id || labelCtx.id}
      options={{
        mask: Number,
        ...options
      }}
      value={props.value ? props.value.toString() : ''}
      onChange={handleOnChange}
      rightAlign={rightAlign}
      aria-labelledby={props.describedBy || labelCtx.describedBy}
    />
  );
};
